
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinalandi() {



    const cardData =
    {
        keyword: 'Cab Service in Alandi',
        heading: 'Platinum24 Cabs: Cab Service in Alandi',
        headingDescription: ' Platinum24 Cabs offers dependable Cab Service in Alandi, perfect for pilgrims, families, and daily commuters. Whether you’re visiting the revered Sant Dnyaneshwar Temple, traveling for business, or planning an outstation trip, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride. With professional chauffeurs, punctual service, and transparent pricing, we make every journey stress-free. From local travel within Alandi to airport transfers and long-distance routes, Platinum24 Cabs guarantees reliable service and a pleasant travel experience for all passengers.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


      "services": [
    {
      "name": "Alandi Cab Service",
      "description": "Discover hassle-free travel in Alandi with our reliable Alandi Cab Service, designed to cater to the needs of locals and visitors alike. Our fleet of well-maintained vehicles ensures comfortable and safe rides for short trips, daily commutes, or sightseeing tours. We emphasize punctuality, cleanliness, and professionalism, making your journey stress-free and enjoyable. With easy booking options available online or via phone and 24/7 customer support, our Alandi Cab Service is your trusted partner for all transportation needs in the city and surrounding areas."
    },
    {
      "name": "Taxi Service Alandi",
      "description": "Our Taxi Service Alandi offers a comprehensive range of travel solutions for local and outstation journeys. Whether you're heading to work, attending an event, or traveling for leisure, our wide variety of vehicles and skilled drivers ensure a comfortable, timely, and safe trip every time. With transparent pricing, convenient booking platforms, and a focus on customer satisfaction, our taxi service is tailored to meet the diverse needs of individuals, families, and corporate clients in Alandi."
    },
    {
      "name": "Alandi Local Taxi",
      "description": "Navigate the bustling streets of Alandi with ease by using our Alandi Local Taxi service. Perfect for quick errands, daily commutes, or visiting local landmarks, our taxis provide prompt and affordable transportation options. Equipped with air conditioning and regularly sanitized vehicles, our service prioritizes your comfort and safety. Our professional drivers are knowledgeable about the best routes to avoid traffic and get you to your destination swiftly and securely."
    },
    {
      "name": "Affordable Taxi Alandi",
      "description": "Travel smart and save with our Affordable Taxi Alandi service, offering budget-friendly rides without compromising on quality or comfort. Ideal for students, professionals, and families looking for economical transportation solutions, our fleet includes fuel-efficient vehicles maintained to the highest standards. Transparent fare structures and frequent promotions ensure you get the best value. Whether it’s a quick trip around town or a longer journey, our affordable taxi service keeps your wallet happy."
    },
    {
      "name": "Alandi Taxi with Driver",
      "description": "Relax and enjoy the ride with our Alandi Taxi with Driver service, offering the convenience of professional drivers who prioritize your safety and comfort. Our experienced drivers are well-versed with local routes and traffic conditions, making your journey smooth and efficient. This service is perfect for corporate travelers, families, and tourists seeking a stress-free transportation experience. Vehicles are meticulously maintained and sanitized regularly to ensure a clean and pleasant ride."
    },
    {
      "name": "Alandi Airport Taxi",
      "description": "Make your airport transfers seamless with our dependable Alandi Airport Taxi service. We offer timely pickups and drop-offs to Pune and other regional airports, with drivers monitoring your flight status to accommodate delays or early arrivals. Our spacious vehicles comfortably accommodate passengers and luggage, ensuring a smooth start or end to your journey. Fixed, upfront pricing means no surprises, and our friendly drivers provide professional service from door to terminal."
    },
    {
      "name": "Cab Rental Alandi",
      "description": "Experience flexible and convenient travel with our Cab Rental Alandi service, perfect for daily use, weekend trips, or extended rentals. Choose from a range of vehicles, including sedans, SUVs, and compact cars, with options for self-drive or chauffeur-driven rentals. Our cabs are regularly serviced, sanitized, and equipped with modern amenities to ensure a comfortable and safe ride. Transparent pricing and easy online booking make renting a cab in Alandi hassle-free."
    },
    {
      "name": "Alandi Outstation Taxi",
      "description": "Plan your outstation trips confidently with our Alandi Outstation Taxi service, offering reliable transportation for intercity travel and longer journeys. Our skilled drivers are experienced in highway routes, toll management, and passenger safety, ensuring a smooth and enjoyable ride. Whether traveling for business, leisure, or family visits, our outstation taxis provide comfortable seating, ample luggage space, and transparent pricing. Flexible booking options and 24/7 support enhance your travel experience."
    },
    {
      "name": "Alandi Corporate Taxi",
      "description": "Elevate your business travel with our Alandi Corporate Taxi service, tailored to meet the unique needs of corporate clients. From daily employee pickups to executive transportation for meetings and client visits, we offer professional, punctual, and discreet service. Our corporate clients benefit from customizable plans, monthly invoicing, GST-compliant billing, and dedicated account management. Maintain your company’s professionalism and efficiency with our reliable corporate taxi solutions."
    },
    {
      "name": "Alandi Taxi Deals",
      "description": "Unlock special savings with our exclusive Alandi Taxi Deals, designed to make your travel more affordable without sacrificing quality. Enjoy discounts on early bookings, seasonal offers, weekend specials, and referral bonuses. Our transparent pricing ensures no hidden fees, giving you confidence and peace of mind. These deals apply to both local and outstation trips, providing excellent value whether you travel occasionally or frequently. Join our loyalty program to maximize your savings on future rides."
    },
    {
      "name": "Alandi City Taxi",
      "description": "Move around Alandi easily with our dependable Alandi City Taxi service, offering comfortable, safe, and timely rides across the city. Whether commuting to work, attending social events, or exploring the city, our professional drivers provide courteous service and navigate the best routes to avoid traffic. Vehicles are equipped with GPS for accurate tracking and air conditioning for a pleasant journey. Flexible booking options and competitive rates make city travel convenient and affordable."
    },
    {
      "name": "Alandi Family Taxi Service",
      "description": "Travel together with your loved ones using our Alandi Family Taxi Service, specially designed for family outings, events, and sightseeing tours. Our spacious vehicles comfortably accommodate families of all sizes, with amenities such as child safety seats available on request. Our drivers prioritize safety and a smooth ride, making your family trips enjoyable and worry-free. Convenient booking options and affordable rates ensure that family travel is both easy and economical."
    },
    {
      "name": "Taxi Booking Online Alandi",
      "description": "Book your taxi anytime and anywhere with Taxi Booking Online Alandi, a seamless and intuitive platform for all your transportation needs. Select your vehicle type, rental duration, and pickup/drop-off locations with ease. Secure payment options and instant confirmation streamline your experience. Real-time updates and 24/7 customer support provide assistance whenever you need it, making your travel planning effortless and stress-free."
    },
    {
      "name": "Alandi Taxi Service 24x7",
      "description": "No matter the time, our Alandi Taxi Service 24x7 is ready to serve you with reliable transportation whenever you need it. Whether it’s an early morning ride, late-night emergency, or any time in between, our professional drivers and well-maintained vehicles ensure safe and prompt service. Flexible booking options, fast response times, and around-the-clock customer support make our 24x7 taxi service your dependable choice for all travel requirements in Alandi."
    }
  ],
  "tableData": [
    ["Alandi Cab Service", "Taxi Service Alandi"],
    ["Alandi Local Taxi", "Affordable Taxi Alandi"],
    ["Alandi Taxi with Driver", "Alandi Airport Taxi"],
    ["Cab Rental Alandi", "Alandi Outstation Taxi"],
    ["Alandi Corporate Taxi", "Alandi Taxi Deals"],
    ["Alandi City Taxi", "Alandi Family Taxi Service"],
    ["Taxi Booking Online Alandi", "Alandi Taxi Service 24x7"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service in Alandi",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and affordable cab services in Alandi for all your travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and preferences."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a safe and comfortable ride in Alandi."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Alandi Area",
    "WhyChoosedescription": "Our professional drivers know Alandi’s routes well to provide smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances for hassle-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist you with cab bookings in Alandi."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Choose hourly, daily, or long-term rental plans tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Alandi cab quickly and securely through our website or app with real-time confirmation."
  }
]
















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Nigdi?',
        answer: 'Yes, Platinum24 Cabs provides reliable and efficient cab services in Nigdi for all your travel needs.',
    },
    {
        question: 'How can I book a cab service in Nigdi with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Nigdi?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences.',
    },
    {
        question: 'Can I use the cab service in Nigdi for local and outstation travel?',
        answer: 'Yes, Platinum24 Cabs offers cab services for both local trips within Nigdi and outstation travel.',
    },
    {
        question: 'Are the drivers experienced and familiar with Nigdi routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Nigdi and nearby areas.',
    },
    {
        question: 'Is hourly and daily cab service available in Nigdi?',
        answer: 'Yes, we provide flexible hourly and daily cab packages tailored to your travel plans.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cabs in Nigdi?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure passenger safety.',
    },
    {
        question: 'Is cab service in Nigdi available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Nigdi.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Nigdi?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for seamless transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Nigdi for cab service?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Nigdi as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Abhijit Deshpande',
        feedback: 'The cab service in Nigdi by Platinum24 Cabs was punctual, safe, and very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Jadhav',
        feedback: 'Highly recommend Platinum24 Cabs for reliable and friendly cab service in Nigdi.',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const alandiCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Trusted and affordable cab service in Alandi offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Alandi, Pune"
  },
  "serviceType": [
    "Alandi Cab Service",
    "Taxi Service Alandi",
    "Alandi Local Taxi",
    "Affordable Taxi Alandi",
    "Alandi Taxi with Driver",
    "Alandi Airport Taxi",
    "Cab Rental Alandi",
    "Alandi Outstation Taxi",
    "Alandi Corporate Taxi",
    "Alandi Taxi Deals",
    "Alandi City Taxi",
    "Alandi Family Taxi Service",
    "Taxi Booking Online Alandi",
    "Alandi Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};





    return (
        <div>

<Helmet>
  <title>Cab Service in Alandi | Affordable Taxi Service Alandi Pune</title>
  <meta
    name="description"
    content="Trusted and affordable cab service in Alandi offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Alandi Cab Service, Taxi Service Alandi, Alandi Local Taxi, Affordable Taxi Alandi, Alandi Taxi with Driver, Alandi Airport Taxi, Cab Rental Alandi, Alandi Outstation Taxi, Alandi Corporate Taxi, Alandi Taxi Deals, Alandi City Taxi, Alandi Family Taxi Service, Taxi Booking Online Alandi, Alandi Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(alandiCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/85.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinalandi;